export const GET_ADMIN_ACCESS = "GET_ADMIN_ACCESS";
export const GET_ADMIN_ACCESS_BY_ADMIN_ID = "GET_ADMIN_ACCESS_BY_ADMIN_ID";
export const CREATE_ADMIN_ACCESS = "CREATE_ADMIN_ACCESS";
export const UPDATE_ADMIN_ACCESS = "UPDATE_ADMIN_ACCESS";
export const UPDATE_ADMIN_ROLE = "UPDATE_ADMIN_ROLE";
export const UPDATE_FEATURE_ACCESS = "UPDATE_FEATURE_ACCESS";

export const OPEN_ADMIN_ACCESS_DIALOG = "OPEN_ADMIN_ACCESS_DIALOG";
export const CLOSE_ADMIN_ACCESS_DIALOG = "CLOSE_ADMIN_ACCESS_DIALOG";
